import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {LeadComponent} from '@app/product/lead/lead.component';
import {CmsPageGuard} from '@spartacus/storefront';
import {LeadButtonComponent} from '@app/product/lead/lead-button/lead-button.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'lead/:product',
        canActivate: [CmsPageGuard],
        component: LeadComponent
      },
      {
        path: 'lead-button/:product',
        canActivate: [CmsPageGuard],
        component: LeadButtonComponent
      },
    ])
  ]
})
export class LeadModule {
}
